import type { SVGProps } from "react";

/**
 * TransferMoney icon from Figma - two horizontal arrows (left and right)
 * SVG paths extracted from Figma design file
 */
export function IconTransferMoney(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Arrow pointing left (top) */}
      <path
        d="M4 8H20M4 8L7 5M4 8L7 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Arrow pointing right (bottom) */}
      <path
        d="M20 16H4M20 16L17 13M20 16L17 19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
